import { render, staticRenderFns } from "./EditBuyerReceiving.vue?vue&type=template&id=1ff89e57&"
import script from "./EditBuyerReceiving.vue?vue&type=script&lang=js&"
export * from "./EditBuyerReceiving.vue?vue&type=script&lang=js&"
import style0 from "./EditBuyerReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports